import React, { useEffect, useRef, useState } from "react";
import { Card, Container } from "react-bootstrap";
import { withRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "shards-ui/dist/css/shards.min.css";
import { strings } from "../../localization";
import OrderItemsCard from "../../components/OrderItemsCard";
import EmptyOrderComponent from "../../components/EmptyOrderComponent";
import Loading from "../../components/Loading";
import CustomNavbar from "../../components/navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import { getCurrentOrPastOrders } from "../../api/ApiServices";
import { compareDates, ROUTE_PREFIX } from "../../config";

const PastOrders = ({ match, location, history }) => {
  const { restaurantName } = match.params || {};
  console.log("DEBUG past order page in restaurantName", restaurantName);
  const [orders, setOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // auto refresh states
  const intervalIdRef = useRef(null);
  const [lastUpdatedDate, setLastUpdatedData] = useState("");
  const lastUpdatedDateRef = useRef("");
  const loadingRef = useRef(true);

  const getPastOrders = () => {
    getCurrentOrPastOrders(true)
      .then(async (res) => {
        let orderData = [];
        if (res.status === 200) {
          const parsedJson = await res.json();
          const result = parsedJson.result;
          const data = result.data || [];

          // TODO: ONCE last updated date functionality added from backend side
          let currentDate = result["lastUpdatedAt"]
            ? result["lastUpdatedAt"]
            : "";
          console.log("🚀 ~ getPastOrders ~ currentDate:", currentDate);
          console.log(
            "lastUpdatedDate in getPastOrders function",
            lastUpdatedDateRef.current
          );
          if (compareDates(lastUpdatedDateRef.current, currentDate)) {
            console.log("compareDate function called now loading will be true");
            setIsLoading(true);
          }

          if (data && Array.isArray(data)) {
            data.map((item) => {
              let obj = item.data;
              obj = Object.assign({ id: item._id }, obj);
              orderData.push(obj);
            });
          }
          console.log("orderData", orderData);
          setLastUpdatedData(currentDate);
          setOrders(orderData);
          setIsLoading(false);
        } else {
          console.log("current orders api error", res);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(
          "catch block error while getting current orders data",
          error
        );
      });
  };

  // useState(() => {
  //   getPastOrders();
  // }, []);

  // Auto refresh functionality functions

  useEffect(() => {
    loadingRef.current = isLoading;
  }, [isLoading]);

  useEffect(() => {
    lastUpdatedDateRef.current = lastUpdatedDate;
  }, [lastUpdatedDate]);

  // const getPastKOTOrderData = useCallback(() => {
  //   getPastOrders();

  //   console.log("dev-log 1 getPastKOTOrderData func called!");
  //   // Call the function every 5 seconds (5000 milliseconds)
  //   intervalIdRef.current = setInterval(getPastOrders, 5000);
  // }, []);

  // useEffect(() => {
  //   getPastKOTOrderData();
  //   return () => {
  //     clearInterval(intervalIdRef.current);
  //     intervalIdRef.current = null; // Reset interval ID
  //   };
  // }, [getPastKOTOrderData]);

  useEffect(() => {
    getPastOrders();
    const intervalId = setInterval(() => {
      getPastOrders();
    }, 5000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <Container
      fluid
      className="p-0 d-flex flex-column vh-100"
      style={{ overflow: "scroll" }}
    >
      {/* Header Section */}
      <CustomNavbar pageName={strings.past_orders} />
      {isLoading ? (
        <Loading />
      ) : (
        <div style={{ marginTop: "0.7rem" }}>
          {orders.length > 0 ? (
            orders.map((order) => {
              return (
                <OrderItemsCard
                  key={order.id}
                  order={order}
                  onCardClick={(data) => {
                    history.replace(`/${ROUTE_PREFIX}${restaurantName}/orders/${data.id}`, {
                      routeName: `/${ROUTE_PREFIX}${restaurantName}/past-orders`,
                      orderData: order,
                    });
                  }}
                />
              );
            })
          ) : (
            <EmptyOrderComponent title={strings.no_past_orders} />
          )}
        </div>
      )}
      <Footer />
    </Container>
  );
};

export default withRouter(PastOrders);
